module.exports = __webpack_public_path__ + "img/close-icon.5b0b536c.svg";